import Link from "next/link";
import React, { useState } from "react";
import helper from "../../lib/helper";
import reviewsModel from "../../models/reviews.model";
import useSWR from "swr";
import Pagination from "../../components/Pagination";
import Heading from "../../components/Heading";
import Table from "../../components/Table";
import { useRouter } from "next/router";
import config from "../../lib/config";
import moment from "moment/moment";
import { Card, CardBody, Modal, ModalBody } from "react-bootstrap";
import { useForm } from "react-hook-form";

const Page = function () {
  const [showLoader, setShowLoader] = useState(false);
  const [show, setShow] = useState(false);
  const [selectedReview, setselectedReview] = useState(null); // Add this state

  const handleShow = (review) => {
    setselectedReview(review); // Set the selected review
    setShow(true);
  };
  const handleClose = () => {
    setShow(false);
    setselectedReview(null); // Clear selection on close
  };

  const router = useRouter();
  const queryParams = router.query;
  const {
    data: reviewsData,
    mutate: reloadreviewsData,
    isLoading,
  } = useSWR(
    queryParams || null,
    () => reviewsModel.list(queryParams),
    config.swrConfig,
  );

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
    setError,
    reset,
  } = useForm();

  
  
  
 const toggleStatus = async (id) => {
  setShowLoader(true);
  try {
    const response = await reviewsModel.toggleStatus(id);
    helper.sweetalert.toast(
      response.data?.message ||
        `Review updated successfully`
    );
    reloadreviewsData();
  } catch (error) {
    console.log(error)
    helper.sweetalert.toast(
      error.response?.data?.message || "Something went wrong",
      "error"
    );
  } finally {
    setShowLoader(false);
  }
};
  
  
  
  const onSubmit = async (data, event) => {
    const formData = new FormData(event.target);

    await reviewsModel
      .reply(selectedReview?.id, formData)
      .then((response) => {
        helper.sweetalert.toast(response.data?.message);

        handleClose(true);
        reset();
      })
      .catch((error) => {
        helper.sweetalert.toast(error.response?.data?.message, "error");
        _.each(error.response?.data?.errors, function (err, errorKey) {
          setError(errorKey, { type: "required", message: err });
        });
      });
  };
  const columns = [
    {
      Header: "Reviews",
      accessor: "comment",
      className: "col",
      Cell: ({ row }) => (
        <div>
          {/* Review */}
          <div
            className="text-truncate"
            style={{ maxWidth: "300px" }}
            title={row.original.comment}
          >
            {row.original.comment}
          </div>

          {/* Reply */}
          {row.original.replies?.map((reply, index) => (
            <div
              key={index}
              className="mt-2 p-2 bg-light text-black border-start border-primary d-flex"
            >
              <small className="fw-bold d-block me-1">Reply:</small>

              <div>{reply.comment}</div>
            </div>
          ))}
        </div>
      ),
    },
    {
      Header: "Rating",
      accessor: "rating",
      className: "col",
    },
    {
      Header: "User",
      className: "col",
      Cell: ({ row }) => (
        <>
          <div>{row.original.user.name}</div>
        </>
      ),
    },
    {
      Header: "Date",
      id: "created_at",
      Cell: ({ row }) => (
        <>
          <div>{helper.date.format(row.original.created_at)}</div>
        </>
      ),
    },
   {
  className: "col-auto text-end",
  Header: "Actions",
  id: "action",
  Cell: ({ row }) => (
    <div className="btn-group btn-group-sm">
      <button
        className="btn btn-success"
        onClick={() => toggleStatus(row.original.id)}
        disabled={row.original.status === 1}
        title="Approve"
      >
        <i className="bi bi-hand-thumbs-up"></i>
      </button>
      <button
        className="btn btn-danger"
        onClick={() => toggleStatus(row.original.id)}
        disabled={row.original.status === 0}
        title="Reject"
      >
        <i className="bi bi-ban"></i>
      </button>
      <button
        className="btn"
        onClick={() => handleShow(row.original)}
        title="Reply"
      >
        <i className="bi bi-chat"></i>
      </button>
    </div>
  ),
},
  ];

  return (
    <>
      <Heading title="reviews" showLoader={isLoading || showLoader}></Heading>
      <div className="container-fluid">
        <div className="card">
          <div className="card-header">List of reviews</div>
          <div className="table-responsive">
            <Table columns={columns} data={reviewsData?.data || []} />
          </div>
          <div className="card-footer">
            <Pagination meta={reviewsData?.meta} />
          </div>
        </div>
      </div>

      {/* Modal moved outside the table */}
      <Modal show={show} onHide={handleClose}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Card>
            <Card.Header>
              <h5>Reply section</h5>
            </Card.Header>
            <Card.Body>
              {selectedReview ? (
                <>
                  {/* <p>{selectedReview.id}</p> */}
                  <input
                    type="text"
                    className="w-100 p-3"
                    placeholder="Reply here"
                    name="reply"
                    {...register("comment")}
                  />
                </>
              ) : (
                <p>No review selected</p>
              )}
            </Card.Body>
            <Card.Footer>
              <button className="btn btn-secondary" onClick={handleClose}>
                Close
              </button>
              {/* Add any messenger-specific actions here */}
              <button className="btn btn-primary ms-2" type="submit">
                <i className="bi bi-send"></i>
              </button>
            </Card.Footer>
          </Card>
        </form>
      </Modal>
    </>
  );
};

export default Page;
